import { type AlertProps, Text } from "@chakra-ui/react";
import { BannerAlert } from "@equidefi/ui";

import type React from "react";

interface NoFilesWarningProps extends Omit<AlertProps, "status"> {
  text: string;
  title: string;
}

export const NoFilesWarning: React.FC<NoFilesWarningProps> = ({
  title = "No Documents Uploaded",
  text = "Upload your documents to get started.",
  ...rest
}) => (
  <BannerAlert
    status="warning"
    title={title}
    {...rest}
    description={
      <Text textStyle="body2" m="0">
        {text}
      </Text>
    }
  />
);
